import React from "react"
import { BaseViewProp } from "../../types/type"
import Style from "./Card.module.css"

export default function Card({ children }: BaseViewProp): React.ReactElement {
  return <div className={Style.card}>{children}</div>
}
